export default function () {
    return process.browser ? window.location.hash.replace('#', '') : '';
}
